<div class="faq" [ngClass]="{ open: isOpen }">
	<div class="question" (click)="isOpen = !isOpen">
		<span [interact]="!isOpen && { engagementTypeID: 5, resource: 'Question #' + index }" [innerHTML]="question"></span>
		<div class="arrow" [interact]="!isOpen && { engagementTypeID: 5, resource: 'Question #' + index }"></div>
	</div>
	<div class="answer">
		<div class="content"><ng-content></ng-content></div>
	</div>
</div>
